import { dashboardAxios, buildAuthenticationHeaders } from './global';

const getCampaigns = (credentials, brandId) =>
  dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/brands/${brandId}/campaigns`, {
      ...buildAuthenticationHeaders(credentials)
  });

const getCampaign = (credentials, campaignId, brandId) =>
  dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/brand/${brandId}/campaigns/${campaignId}`, {
      ...buildAuthenticationHeaders(credentials)
  });

const getCampaignOfMainAccount = (credentials, campaignId, brandId, accountId) =>
    dashboardAxios.get(`/messages-10dlc/api/account/${accountId}/brand/${brandId}/campaigns/${campaignId}`, {
        ...buildAuthenticationHeaders(credentials)
    });

const createCampaign = (credentials, brandId, campaign) =>
  dashboardAxios.post(`/messages-10dlc/api/account/${credentials.accountId}/brands/${brandId}/campaigns`, campaign, {
      ...buildAuthenticationHeaders(credentials)
  });

// Check if we can remove the reseller_id, if it's not return an error
const updateCampaign = (campaign, brandId, credentials) =>
  dashboardAxios.patch(`/messages-10dlc/api/account/${credentials.accountId}/brands/${brandId}/campaigns/${campaign.id}`,  {
      ...campaign, reseller_id: null }, { ...buildAuthenticationHeaders(credentials) });

const qualifyBrand = (usecase, brandId, credentials) =>
  dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/brands/${brandId}/usecases/${usecase}`, {
      ...buildAuthenticationHeaders(credentials)
  });

const deleteCampaign = (campaignId, brandId, credentials) =>
  dashboardAxios.delete(`/messages-10dlc/api/account/${credentials.accountId}/brand/${brandId}/campaigns/${campaignId}`, {
    ...buildAuthenticationHeaders(credentials)
});

const linkNumberToCampaign = (credentials, campaignId, phoneNumber) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${credentials.accountId}/campaign/${campaignId}/number`, {phone_number: phoneNumber}, {
        ...buildAuthenticationHeaders(credentials)
    });

const unlinkNumberToCampaign = (credentials, campaignId, phoneNumber) =>
    dashboardAxios.delete(`/messages-10dlc/api/account/${credentials.accountId}/campaign/${campaignId}/number`, {
        data: {phone_number: phoneNumber}, ...buildAuthenticationHeaders(credentials)
    });

export {
    getCampaigns,
    getCampaign,
    createCampaign,
    qualifyBrand,
    updateCampaign,
    deleteCampaign,
    linkNumberToCampaign,
    unlinkNumberToCampaign,
    getCampaignOfMainAccount
};
